import React from 'react'
import { Grid } from 'semantic-ui-react'
import DropDown from '../../../commonComponents/formComponents/dropDown'
import { useSelector,useDispatch } from 'react-redux'
import { useSelectCountry } from '../../hooks/useSelectCountry'
import {addItemsTabWarnings,deleteItemsTabWarnings} from "../../actions/errorValidationActions";
import { validation } from '../../util/cdsFieldPatterns';
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType'
import InputField from '../../../commonComponents/formComponents/inputField'

const MerchForm3 = ({
  isFormDisabled,
  merchandiseId,
  updateData,
  saveData, 
  saveFieldAndUpdateWithResponse,
  invoiceId,
  lineNumber,
  invoiceItemIndex,
  fieldPattern,
  validateError,
})=> {

  const countryList=useSelectCountry()
  const preferenceList=useSelector((state) => state.DropDownValues.preference)
  const transportChargesMOPDropDownValues =
    useSelector((state) => state.DropDownValues?.transportChargesMOP) || []
    const transportChargesMop=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.transportChargesMop)

  const dispatchCountry=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.dispatchCountry) || ' '
  const destinationCountry=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.destinationCountry)
  const originCountry=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.originCountry)
  const preferentialOriginCountry=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.preferentialOriginCountry)
  const preference=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.preference)
  const supplementUnits=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.supplementUnits) || ' '
  const natureOfTransaction=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.natureOfTransaction) || ' '
  const { declarationCat = '' } = useSelector((state) => state.Shipment) || []


  const destinationCountryErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_destinationCountry`]) 
  const supplementUnitsErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_supplementUnits`]) 
  const natureOfTransactionErr = useSelector((state)=>state?.ValidationErrors.items?.[`invoice${invoiceItemIndex+1}_lineItem${lineNumber}_natureOfTransaction`]) 



  const getValidationError = React.useMemo(
    () => validation(declarationCat, 'itemsTab'),
    [declarationCat]
  )

  const addErrors = (level, value, fieldName) => {
    dispatch(addItemsTabWarnings(level, value, fieldName))
  }
  const deleteErrors = (level, value, fieldName) => {
    dispatch(deleteItemsTabWarnings(level, value, fieldName))
  }
  const dispatch=useDispatch()

  const {serviceType} = useCurrentShipmentType()

 
  return (
    <Grid.Row>
      {
        serviceType === 'IM' &&
        <Grid.Column width='4' className='divFormFeild b-rw-0'>
        <DropDown
            id={`dispatchCountry-${invoiceId}-${merchandiseId}`}
            label='Dispatch Country'
            disabled={isFormDisabled}
            boxNumber='5/14'
            className='field-bg dropdown100 addInfoCode'
            labelClass='text-none'
            mandatory={false}
            isLabel={true}
            data={countryList}
            clearable
            value={dispatchCountry}
            errors={getValidationError("dispatchCountry",dispatchCountry,true)}
            onChange={(value) =>{
              updateData({dispatchCountry:value?.trim()})
              saveData({dispatchCountry:value})
              let err = getValidationError('dispatchCountry', value, 'itemsTab',true)
                            err.length
                              ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `dispatchCountry-${merchandiseId}`)
                              : deleteErrors('itemsTab', '', `dispatchCountry-${merchandiseId}`)
            }
          }
            
          />
  </Grid.Column>
      }
     
<Grid.Column width='3' className='divFormFeild b-rw-0'>
<DropDown
          id={`destinationCountry-${invoiceId}-${merchandiseId}`}
          label='Destination Country'
          disabled={isFormDisabled}
          boxNumber='5/8'
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          mandatory={false}
          isLabel={true}
          data={countryList}
          value={destinationCountry}
          errors={serviceType === 'IM' ? 
          getValidationError("destinationCountry",destinationCountry,true) :
          destinationCountryErr && destinationCountryErr?.msg            
          }
          clearable
          onChange={(value) =>{
            updateData({destinationCountry:value?.trim()})
            saveData({destinationCountry:value})
            const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_destinationCountry`
            validateError(
              { [key]: '' },
              { [key]: value },
              { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.destinationCountry }
            )

            let err = getValidationError('destinationCountry', value, 'itemsTab',true)
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `destinationCountry-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `destinationCountry-${merchandiseId}`)
          }
        }
        />

        </Grid.Column>
        <Grid.Column width='3' className='divFormFeild b-rw-0'>
        <DropDown
          id={`originCountry-${invoiceId}-${merchandiseId}`}
          label='Origin Country'
          disabled={isFormDisabled}
          boxNumber='5/15'
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          mandatory={false}
          isLabel={true}
          data={countryList} 
          value={originCountry}
          clearable
          onChange={(value) =>{
            updateData({originCountry:value?.trim()})
            saveData({originCountry:value})
          }
          }
        />

        </Grid.Column>
        { serviceType ==='IM' &&
        <>
        <Grid.Column width='3' className='divFormFeild b-rw-0'>
        <DropDown
          id={`prefrenceOrigin-${invoiceId}-${merchandiseId}`}
          label='Preferential Origin'
          disabled={isFormDisabled}
          boxNumber='5/16'
          className='field-bg dropdown100 addInfoCode'
          labelClass='text-none'
          mandatory={false}
          isLabel={true}
          data={countryList}
          value={preferentialOriginCountry}
          clearable
          onChange={(value) =>{
            updateData({preferentialOriginCountry:value?.trim()})
            saveData({preferentialOriginCountry:value})
          }
          }
        
        />
        </Grid.Column>
        
        <Grid.Column width='3' className='divFormFeild'>
        <DropDown
            id={`preference-${invoiceId}-${merchandiseId}`}
            label='Preference'
            disabled={isFormDisabled}
            className='field-bg dropdown100 addInfoCode'
            boxNumber='4/17'
            labelClass='text-none'
            isLabel={true}
            mandatory={false}
            direction='left'
            clearable
            data={preferenceList}
            value={preference}
            errors={getValidationError("preference",preference,true)}
            onChange={(value) =>{
              updateData({preference:value?.trim()})
              saveData({preference:value})
              let err = getValidationError('preference', value, 'itemsTab', true)
              err.length
                ? addErrors(
                    'itemsTab',
                    `invoice -00${lineNumber + 1}` + ' :: ' + err[0],
                    `preference-${merchandiseId}`
                  )
                : deleteErrors('itemsTab', '', `preference-${merchandiseId}`)
              
            }
            }
          /> 
      </Grid.Column>
      </>
      }
      {
        serviceType === "EX" &&
        <>
          <Grid.Column width='3' className='divFormFeild b-rw-0'>
      <InputField
          isLabel={false}
          id={`supplementalUnits-${invoiceId}-${merchandiseId}`}
          type='number'
          label='Supplemental Units'
           boxNumber="6/2"
          mandatory={false}
          value={supplementUnits}
          errors={ serviceType !== 'IM' && supplementUnitsErr && supplementUnitsErr?.msg}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}  
          onChange={(value) =>updateData({supplementUnits:value})}
          onBlur={(value)=>{
            saveData({supplementUnits:supplementUnits || " "})
            const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_supplementUnits`
            validateError(
              { [key]: '' },
              { [key]: value },
              { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.supplementUnits }
            )
          }}
        />

    
      </Grid.Column>

      <Grid.Column width='3' className='divFormFeild'>
      <InputField
          isLabel={false}
          id={`transactionNature-${invoiceId}-${merchandiseId}`}
          type='number'
          label='Nature of Transaction'
          boxNumber="8/5"
          mandatory={false}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          value={natureOfTransaction}
          errors={ serviceType === 'IM' ? 
          getValidationError("natureOfTransaction",natureOfTransaction ||" ") : 
          natureOfTransactionErr && natureOfTransactionErr?.msg            
          }
          onChange={(value) =>updateData({natureOfTransaction:value})}
          onBlur={()=>{saveData({natureOfTransaction: natureOfTransaction || " "})

          const key = `invoice${invoiceItemIndex + 1}_lineItem${lineNumber}_natureOfTransaction`
          validateError(
            { [key]: '' },
            { [key]: value },
            { [key]: fieldPattern({declarationCat}).items?.lineItem(invoiceItemIndex + 1, lineNumber)?.natureOfTransaction }
          )

          let err = getValidationError('natureOfTransaction', natureOfTransaction || " ", 'itemsTab')
                          err.length
                            ? addErrors('itemsTab', `invoice -00${lineNumber + 1}`+ ' :: ' +err[0], `natureOfTransaction-${merchandiseId}`)
                            : deleteErrors('itemsTab', '', `natureOfTransaction-${merchandiseId}`)
        }}
        />

    
      </Grid.Column>

      <Grid.Column width='4' className='divFormFeild'>
        <DropDown
            id={`transportChargesMop-${invoiceId}-${merchandiseId}`}
            label='TRANSPORT CHARGES MOP'
            disabled={isFormDisabled}
            className='field-bg dropdown100 addInfoCode'
            boxNumber='4/2'
            labelClass='text-none'
            isLabel={true}
            mandatory={false}
            direction='left'
            clearable
            data={transportChargesMOPDropDownValues}
            value={transportChargesMop}
            onChange={(value) =>{
              updateData({transportChargesMop:value?.trim()})
              saveData({transportChargesMop:value})
                            
            }
            }
          /> 
      </Grid.Column>
        </>
      }
    </Grid.Row>
  )
}

export default React.memo(MerchForm3)
